import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
  Divider,
} from '@mui/material';

interface UnauthorizedPopupProps {
  open: boolean;
  onClose: () => void;
  onLoginRedirect?: () => void;
}

const UnauthorizedPopup: React.FC<UnauthorizedPopupProps> = ({
  open,
  onClose,
  onLoginRedirect,
}) => {
  const handleClose = () => {
    onClose();
    // window.history.back();

    window.location.href = "/"
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="unauthorized-modal-title"
      aria-describedby="unauthorized-modal-description"
    >
     
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(100% - 32px)',
          maxWidth: 420,
          outline: "none",
            bgcolor: 'background.paper',
          border: "2px solid red",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
           
            <Typography
              id="unauthorized-modal-title"
              variant="h6"
              fontWeight="bold"
            >
              Unauthorized Access 🔒
            </Typography>
          </Stack>

          <Divider />

          <Typography id="unauthorized-modal-description" sx={{ mb: 1 }}>
            This page is restricted. You may need special permissions or login
            credentials to continue.
          </Typography>

          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onLoginRedirect}
            >
              Go to Login
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default UnauthorizedPopup;
